import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import "styles/wieldy.less";
import configureStore, { history } from "./appRedux/store";
// import "./firebase/firebase";
import App from "./containers/App/index";
// import { registerFirebaseServiceWorker } from "./register-sw";
// import registerServiceWorker from "./_registerServiceWorker";
import { askForPermissioToReceiveNotifications, initializeFirebase } from "./push-notification";
import { useAuth } from "./contexts/AuthContext";

/* provide initial state if any */
const store = configureStore({});
const NextApp: React.FC = () => {
  const auth = useAuth();

  useEffect(() => {
    // registerFirebaseServiceWorker();
    // registerServiceWorker();
    initializeFirebase();
  }, []);

  useEffect(() => {
    if (auth.userEmployeePosition.personCode) {
      askForPermissioToReceiveNotifications()
    }
  }, [auth.userEmployeePosition.personCode])

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </ConnectedRouter>
    </Provider>
  );
};

export default NextApp;
